export default {
  title: "Aktivitäten",
  subtitle: "Alle Plattform-Aktivitäten",
  searchPlaceholder: "Nach Aktivitäts- oder Eigentümername suchen...",
  loadError: "Aktivitäten konnten nicht geladen werden",
  retry: "Erneut versuchen",
  empty: "Keine Aktivitäten entsprechen Ihren Filtern.",
  openRowAria: "Aktivität {{name}} öffnen",
  filters: {
    status: "Status",
    statusAll: "Alle",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    visibility: "Sichtbarkeit",
    visibilityAll: "Alle",
    visibilityVisible: "Sichtbar",
    visibilityHidden: "Versteckt",
    discounts: "Rabatte",
    discountsAll: "Alle",
    discountsActive: "Aktive Rabatte",
    category: "Kategorie",
    categoryAll: "Alle",
    paymentModel: "Zahlungsmethode",
    paymentModelAll: "Alle",
  },
  paymentModels: {
    upfront: "Vorauszahlung",
    receiptBased: "Belegbasiert",
  },
  categories: {
    restaurant: "Restaurant",
    attraction: "Attraktion",
    genericService: "Service",
  },
  columns: {
    name: "Aktivität",
    category: "Kategorie",
    owner: "Eigentümer",
    paymentModel: "Zahlungsmethode",
    commission: "Provision",
  },
} as const;
